export const PRODUCTION_STATE_VALUES = [
    "draft",
    "story_review",
    "references_review",
    "keyframes_generating",
    "keyframes_review",
    "videos_generating",
    "videos_review",
    "ready",
];
export const ProductionState = {
    DRAFT: "draft",
    STORY_REVIEW: "story_review",
    REFERENCES_REVIEW: "references_review",
    KEYFRAMES_GENERATING: "keyframes_generating",
    KEYFRAMES_REVIEW: "keyframes_review",
    VIDEOS_GENERATING: "videos_generating",
    VIDEOS_REVIEW: "videos_review",
    READY: "ready",
};
export const PRODUCTION_STATE_LABELS = {
    [ProductionState.DRAFT]: "Brouillon",
    [ProductionState.STORY_REVIEW]: "Validation histoire",
    [ProductionState.REFERENCES_REVIEW]: "Validation références",
    [ProductionState.KEYFRAMES_GENERATING]: "Génération des keyframes",
    [ProductionState.KEYFRAMES_REVIEW]: "Planche contact",
    [ProductionState.VIDEOS_GENERATING]: "Génération des vidéos",
    [ProductionState.VIDEOS_REVIEW]: "Revue des vidéos",
    [ProductionState.READY]: "Prêt à publier",
};
